import script from "./HeaderPage.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderPage.vue?vue&type=script&setup=true&lang=js"

import "./HeaderPage.vue?vue&type=style&index=0&id=5f045d15&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f045d15"]])

export default __exports__